import React, { useContext } from "react";
import StudyProgress from "../StudyProgress";
import StudyBtn from "../../../StudyBtn";
import styles from "./index.module.scss";
import Spacer from "../../../../../../../../../../../../components/PreviewSourceModal/components/Spacer";
import { ChapterContext } from "../../../../../../store";

interface ChapterHeader {
    title: string;
    percent: number; // 30% 就写30
}

export default function ChapterHeaders({ title, percent }: ChapterHeader) {
    const { onViewCourseware } = useContext(ChapterContext);

    return (
        <div className={styles.root}>
            <div className={styles.title}>{title}</div>
            <Spacer />
            <StudyProgress percent={percent} />
            <StudyBtn onClick={onViewCourseware} />
        </div>
    );
}
